.has--value > span:first-of-type,
.input-multiline__textarea:focus ~ span:first-of-type {
  top: 1px;
  font-size: 10px;
}

.input-multiline__textarea:focus ~ span,
.input-multiline__textarea:focus > span {
  color: var(--clrs-text-placeholder-hover);
}

.input-multiline__textarea::-webkit-scrollbar {
  /* WebKit */
  width: 0;
  height: 0;
}

.input-multiline__label {
  @apply flex md:flex-col relative;

  font-family: var(--typography-comment);
  background-color: var(--clrs-bg-comment-default);
}

.input-multiline__label--disabled {
  background-color: var(--clrs-bg-comment-disabled);
}

.input-multiline__textarea {
  /* overflow-y: scroll; */
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;

  @apply w-full md:w-auto resize-none;
  @apply border text-base leading-6 outline-none pb-2 pt-4 pl-4 pr-3;
  @apply transition-colors;

  font-family: var(--typography-comment);
  border-radius: var(--radius-comment);
  border-color: var(--clrs-border-comment-default);
  background-color: var(--clrs-bg-comment-default);
}

.input-multiline__textarea:hover {
  border-color: var(--clrs-border-comment-hover);
  background-color: var(--clrs-bg-comment-default);
}

.input-multiline__textarea--error {
  border-color: var(--clrs-border-comment-error);
  background-color: var(--clrs-bg-comment-default);
}

.input-multiline__textarea--disabled {
  border-color: var(--clrs-border-comment-disabled);
  background-color: var(--clrs-bg-comment-disabled);
}

.input-multiline__span {
  @apply text-sm origin-top-left pointer-events-none cursor-text absolute max-h-3.5 pb-2 inset-x-4 inset-y-4 transition-all;

  color: var(--clrs-text-comment-default);
  background-color: var(--clrs-bg-comment-default);
}

.input-multiline__span--disabled {
  color: var(--clrs-text-comment-disabled);
  background-color: var(--clrs-bg-comment-disabled);
}

.input-multiline__error-message {
  color: var(--clrs-subtext-comment-error);

  @apply text-xs;
}

.input-multiline__remaining-chars {
  @apply text-xs;
}
